
<div class="reactions d-flex justify-content-start align-items-center">
        <thread-emoticon-reactions [reactions]="reactions"
                                   [value]="currentReaction" 
                                   [options]="REACT_OPTIONS"  
                                   (onReaction)="react($event)"></thread-emoticon-reactions>
        <span class="px-2">•</span>                      
        <small class="date" [matTooltip]="$safeNavigationMigration(thread?.datetime) | date: 'mediumDate'" matTooltipPosition="above">
            @if(thread.isEdited){<i> {{ 'thread_reactions.edited' | translate }} <span class="px-2">•</span> </i>}{{$safeNavigationMigration(thread?.datetime) | time_from_now }}
        </small>
</div>
